import React, { useEffect, useState } from 'react'
import iconTop1 from 'assets/images/eventBoatRacing/iconTop1.png'
import iconTop2 from 'assets/images/eventBoatRacing/iconTop2.png'
import iconTop3 from 'assets/images/eventBoatRacing/iconTop3.png'
import { useNavigate } from 'react-router-dom'
import { Col, Row } from 'react-bootstrap'
import CustomTable from '../EventWater/CustomTable'
import BoatRacingHome from './components/BoatRacingHome'
import { useTranslation } from 'react-i18next'
import BoatRacingDetail from './components/BoatRacingDetail'
import BoatRacingRank from './components/BoatRacingRank'
import { useQuery } from 'react-query'
import { getUserQuery } from 'dataLayer/user'
import {
	getCheckEventBoatRacingQuery,
	getRankEventBoatRacingQuery,
} from 'dataLayer/game'
import { PATHS } from 'config/routes'

const listImgRank = {
	1: iconTop1,
	2: iconTop2,
	3: iconTop3,
}

function EventBoatRacing() {
	const navigate = useNavigate()
	const { t } = useTranslation()
	const [tabActive, setTabActive] = useState('EVENT')
	const [dataTableRanks, setDataTableRanks] = useState([])
	const [dataTableMyRanks, setDataTableMyRanks] = useState([])
	const [current, setCurrent] = useState(1)
	const [totalPages, setTotalPages] = useState(0)
	const [showMyRank, setShowMyRank] = useState(0)
	const [pageSize, setPageSize] = useState(10)
	const { data: user, isLoading: isUserLoading } = useQuery(getUserQuery())
	const {
		data: eventBoatRacing,
		isLoading: isLoadingEvent,
		refetch: refetchEventBoatRacing,
	} = useQuery(getCheckEventBoatRacingQuery())

	const {
		data: rankBoatRacing,
		isLoading: isLoadingRank,
		refetch: refetchRank,
	} = useQuery(getRankEventBoatRacingQuery(current, showMyRank, pageSize))

	const onPressTab = tab => {
		if (tab !== tabActive) {
			setTabActive(tab)
		}
	}

	const columns = [
		{
			title: t('event.boat_racing.detail.transaction'),
			dataIndex: 'package',
			align: 'center',
		},
		{
			title: t('event.boat_racing.detail.number'),
			dataIndex: 'number',
			align: 'center',
		},
	]

	const data = [
		{
			package: t('event.boat_racing.detail.winning'),
			number: '1',
		},
		{
			package: t('event.boat_racing.detail.register'),
			number: '2',
		},
		{
			package: t('event.boat_racing.detail.package_1'),
			number: '2',
		},
		{
			package: t('event.boat_racing.detail.package_2'),
			number: '3',
		},
		{
			package: t('event.boat_racing.detail.package_3'),
			number: '7',
		},
		{
			package: t('event.boat_racing.detail.package_4'),
			number: '20',
		},
		{
			package: t('event.boat_racing.detail.package_5'),
			number: '45',
		},
	]

	const columnsRank = [
		{
			title: t('event.boat_racing.rank.rank'),
			width: '12%',
			dataIndex: 'rank',
			align: 'center',
			render: text => {
				if (text == 1 || text == 2 || text == 3) {
					return (
						<div
							style={{
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
							}}
						>
							<img src={listImgRank[text]} />
						</div>
					)
				} else {
					return text
				}
			},
		},
		{
			title: t('event.boat_racing.rank.name'),
			width: '25%',
			dataIndex: 'full_name',
			align: 'center',
			render: (text, row) => {
				if (!text || text === '0') {
					return row.msisdn
				}
				return text
			},
		},
		{
			title: t('event.boat_racing.rank.isdn'),
			width: '25%',
			dataIndex: 'msisdn',
			align: 'center',
		},
		{
			title: t('event.boat_racing.rank.round'),
			width: '20%',
			dataIndex: 'round',
			align: 'center',
		},
		{
			title: t('event.boat_racing.rank.step'),
			width: '20%',
			dataIndex: 'step',
			align: 'center',
		},
	]

	const onChangePage = page => {
		setCurrent(page)
	}
	useEffect(() => {
		if (eventBoatRacing && !isLoadingEvent) {
			if (!eventBoatRacing.is_show || eventBoatRacing.is_finished) {
				navigate(PATHS.HOME_PAGE)
			}
		}
	}, [eventBoatRacing, isLoadingEvent])

	useEffect(() => {
		if (+rankBoatRacing?.ranks.total) {
			const total = Math.floor(+rankBoatRacing?.ranks.total / pageSize)
			if (+rankBoatRacing?.ranks.total % pageSize) {
				setTotalPages(total + 1)
			} else {
				setTotalPages(total)
			}
		}

		if (!isLoadingRank && rankBoatRacing?.ranks.data.length > 0) {
			const newRankList = rankBoatRacing?.ranks.data.map((item, index) => ({
				...item,
				rank: index + 1 + (current - 1) * pageSize,
			}))
			console.log('newRankList', newRankList)
			setDataTableRanks(newRankList)
		}

		if (user && rankBoatRacing?.myRank) {
			const myRank = {
				...rankBoatRacing?.myRank,
				rank: rankBoatRacing?.myRank?.position,
			}
			console.log('myRank', myRank)
			setDataTableMyRanks([myRank])
		} else {
			setDataTableMyRanks([])
		}
	}, [isLoadingRank, pageSize, rankBoatRacing])

	useEffect(() => {
		// refetchEventBoatRacing()
		setShowMyRank(user ? 1 : 0)
	}, [user])
	useEffect(() => {
		if (tabActive === 'RANK') {
			refetchRank()
		}
	}, [user, tabActive])

	return (
		<div className="container-water container-boat-racing">
			<div className="container-water-wrapper">
				<Row justify="center" className="m-0">
					<Col sx={24} className="p-0">
						<div
							className={`container-water-content container-boat-racing-content ${tabActive.toLowerCase()}`}
						>
							<div className="box-tab">
								<span
									onClick={() => onPressTab('EVENT')}
									className={`box-tab-item unselected ${tabActive == 'EVENT' ? 'active' : ''
										}`}
								>
									{t('event.boat_racing.tab.name_event')}
								</span>
								<span
									onClick={() => onPressTab('DETAIL')}
									className={`box-tab-item unselected ${tabActive == 'DETAIL' ? 'active' : ''
										}`}
								>
									{t('event.boat_racing.tab.detail')}
								</span>
								<span
									onClick={() => onPressTab('RANK')}
									className={`box-tab-item unselected ${tabActive == 'RANK' ? 'active' : ''
										}`}
								>
									{t('event.boat_racing.tab.rank_table')}
								</span>
							</div>
							<div className="box-tab-content">
								{tabActive == 'EVENT' && <BoatRacingHome />}

								{tabActive == 'DETAIL' && (
									<BoatRacingDetail columns={columns} data={data} />
								)}

								{tabActive == 'RANK' && (
									<BoatRacingRank
										columnsRank={columnsRank}
										dataTableRanks={dataTableRanks}
										dataTableMyRanks={dataTableMyRanks}
										rankData={rankBoatRacing}
										isLoadingRank={isLoadingRank}
										onChangePage={onChangePage}
										userData={user}
										current={current}
										totalPages={totalPages}
									/>
								)}
							</div>
						</div>
					</Col>
				</Row>
			</div>
		</div>
	)
}

export default EventBoatRacing
